import _ from 'lodash';

export const titleCase = (string) => string.replace(/\w+/g, _.capitalize);

